import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface DeleteLinkCriteria {
    id: string;
    dashboardId: string;
}

class DeleteLinkCriteriaImpl implements DeleteLinkCriteria {
    constructor(readonly id: string, readonly dashboardId: string) {}
}

export class DeleteLinkCriteriaBuilder {
    private id: Option<string> = none;

    private dashboardId: Option<string> = none;

    static create = (): DeleteLinkCriteriaBuilder => new DeleteLinkCriteriaBuilder();

    withId = (id: string): DeleteLinkCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withDashboardId = (dashboardId: string): DeleteLinkCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    build = (): DeleteLinkCriteria => {
        if (isNone(this.id) || isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new DeleteLinkCriteriaImpl(this.id.value, this.dashboardId.value);
    };
}
